import React from "react";
import StrLeftMenuSAU from "./str/LeftMenuSAU";
import StrLeftMenuCAU from "./str/LeftMenuCAU";
import StrLeftMenuCA from "./str/LeftMenuCA";

import PrymLeftMenuSAU from "./prym/LeftMenuSAU";
import PrymLeftMenuCAU from "./prym/LeftMenuCAU";
import PrymLeftMenuCA from "./prym/LeftMenuCA";

import OtrLeftMenuSAU from "./otr/LeftMenuSAU";
import OtrLeftMenuCAU from "./otr/LeftMenuCAU";
import OtrLeftMenuCA from "./otr/LeftMenuCA";

import TiepLeftMenuSAU from "./tiep/LeftMenuSAU";
import TiepLeftMenuCAU from "./tiep/LeftMenuCAU";
import TiepLeftMenuCA from "./tiep/LeftMenuCA";

import AquaLeftMenuSAU from "./LeftMenuSAU";
import AquaLeftMenuCAU from "./aqua/LeftMenuCAU";
import AquaLeftMenuCU from "./aqua/LeftMenuCU";

import LeftMenuSAU from "./LeftMenuSAU";

import { Auth } from "_helpers";

function LeftMenu() {
  const loggedInCustomerCode = Auth.getProfile().comp_code;
  if (loggedInCustomerCode === "STR") {
    if (Auth.hasRole(Auth.getProfile(), ["SAU"])) {
      return <StrLeftMenuSAU />;
    } else if (Auth.hasRole(Auth.getProfile(), ["CAU"])) {
      return <StrLeftMenuCAU/>;
    } else if (Auth.hasRole(Auth.getProfile(), ["CU"])) {
      return <StrLeftMenuCA />;
    } else {
      return <StrLeftMenuCA/>;
    }
  } else if (loggedInCustomerCode === "PRYM") {
    if (Auth.hasRole(Auth.getProfile(), ["SAU"])) {
      return <PrymLeftMenuSAU/>;
    } else if (Auth.hasRole(Auth.getProfile(), ["CAU"])) {
      return <PrymLeftMenuCAU/>;
    } else if (Auth.hasRole(Auth.getProfile(), ["CU"])) {
      return <PrymLeftMenuCA/>;
    } else {
      return <PrymLeftMenuCA/>;
    }
  } else if (loggedInCustomerCode === "OTR") {
    if (Auth.hasRole(Auth.getProfile(), ["SAU"])) {
      return <OtrLeftMenuSAU/>;
    } else if (Auth.hasRole(Auth.getProfile(), ["CAU"])) {
      return <OtrLeftMenuCAU/>;
    } else if (Auth.hasRole(Auth.getProfile(), ["CU"])) {
      return <OtrLeftMenuCA/>;
    } else {
      return <OtrLeftMenuCA/>;
    }
  } else if (loggedInCustomerCode === "TIEP") {
    if (Auth.hasRole(Auth.getProfile(), ["SAU"])) {
      return <TiepLeftMenuSAU/>;
    } else if (Auth.hasRole(Auth.getProfile(), ["CAU"])) {
      return <TiepLeftMenuCAU/>;
    } else if (Auth.hasRole(Auth.getProfile(), ["CU"])) {
      return <TiepLeftMenuCA/>;
    } else {
      return <TiepLeftMenuCA/>;
    }
  }  else if (loggedInCustomerCode === "AQUA") {
    if (Auth.hasRole(Auth.getProfile(), ["SAU"])) {
      return <AquaLeftMenuSAU/>;
    } else if (Auth.hasRole(Auth.getProfile(), ["CAU"])) {
      return <AquaLeftMenuCAU/>;
    } else if (Auth.hasRole(Auth.getProfile(), ["CU"])) {
      return <AquaLeftMenuCU/>;
    } else {
      return <AquaLeftMenuCU/>;
    }
  } else {
    if (Auth.hasRole(Auth.getProfile(), ["SAU"])) {
      return <LeftMenuSAU />;
    }
  }
}

export { LeftMenu };
